import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { delay: Number }

  connect() {
    this.timeout = null
  }

  disconnect() {
    this.cancel()
  }

  submit() {
    this.cancel()
    this.timeout = setTimeout(() => this.element.requestSubmit(), this.delayValue)
  }

  cancel() {
    if (this.timeout === null) return

    clearTimeout(this.timeout)
    this.timeout = null
  }
}
